import { GcpBox, GcpTypography } from '@back-office/ui';
import { Button, TextField } from '@material-ui/core';
import makeStyles from '@material-ui/core/styles/makeStyles';
import Alert from '@material-ui/lab/Alert';
import { observer } from 'mobx-react';
import React, { FC } from 'react';
import { Controller } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { ForgotPasswordFieldNames, LoginStep } from '../../../forms';
import useViewModel from './viewmodel';

const useStyles = makeStyles(
  () => ({
    desc: {
      padding: '0 10%',
    },
  }),
  { name: 'ForgotPassword' }
);

const ForgotPassword: FC = observer(() => {
  const classes = useStyles();
  const { t } = useTranslation();
  const {
    control,
    handleSubmit,
    errors,
    isDirty,
    isSubmitted,
    isValid,
    handleOnSubmit,
    setLoginStep,
  } = useViewModel();

  return (
    <form autoComplete="off" onSubmit={handleSubmit(handleOnSubmit)}>
      <GcpBox isFullWidth mt={2} textAlign="center">
        <GcpTypography variant="h5">
          {t('login_form.forgot_password')}
        </GcpTypography>
      </GcpBox>
      <GcpBox isFullWidth className={classes.desc} mt={2} textAlign="center">
        <GcpTypography paint="hitGray" variant="body2">
          {t('login_form.forgot_password_description')}
        </GcpTypography>
      </GcpBox>
      <GcpBox isFullWidth mt={4}>
        <Controller
          control={control}
          defaultValue=""
          name={ForgotPasswordFieldNames.Email}
          render={({ onChange, name, value, onBlur }) => (
            <TextField
              fullWidth
              error={!!errors.email?.type}
              label={t('login_form.email')}
              name={name}
              type="text"
              value={value}
              variant="outlined"
              onBlur={onBlur}
              onChange={onChange}
            />
          )}
        />
      </GcpBox>
      {isSubmitted && errors.email?.message && (
        <GcpBox mt={2}>
          <Alert severity="error">
            <GcpTypography paint="flamingo" variant="body1">
              {errors.email?.message}
            </GcpTypography>
          </Alert>
        </GcpBox>
      )}
      <GcpBox isFullWidth mt={2}>
        <Button
          fullWidth
          color="primary"
          disabled={!isDirty || !isValid}
          size="large"
          type="submit"
          variant="contained"
        >
          {t('login_form.forgot_password_continue')}
        </Button>
      </GcpBox>
      <GcpBox isFullWidth mt={2}>
        <Button variant="text" onClick={() => setLoginStep(LoginStep.Login)}>
          <GcpTypography paint="hitGray" variant="body1">
            {t('login_form.back_to_sign_in')}
          </GcpTypography>
        </Button>
      </GcpBox>
    </form>
  );
});

export default ForgotPassword;
